import { useTranslation } from '@rpi/i18n';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export enum urlParamMessageTypeEnum {
  registration_success = 'registration_success',
  password_reset = 'password_reset',
}

interface UrlParamMessageType {
  message: urlParamMessageTypeEnum;
}

export const useUrlParamsMessage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [urlParamMessage, setUrlParamMessage] =
    useState<UrlParamMessageType | null>(null);
  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });
  const clearUrlParamMessage = () => setUrlParamMessage(null);
  useEffect(() => {
    if (searchParams) {
      if (searchParams.get('resetPassword') === 'true') {
        setUrlParamMessage({ message: urlParamMessageTypeEnum.password_reset });
        searchParams.delete('resetPassword');
      }
      if (searchParams.get('registered') === 'true') {
        setUrlParamMessage({
          message: urlParamMessageTypeEnum.registration_success,
        });
        searchParams.delete('registered');
      }
      // This clears the search params from the URL after alert has been set
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams, t]);
  return { urlParamMessage, clearUrlParamMessage };
};
